import Weapon from "./weapon";
import Ammunition from "./ammunition";
import Glyphs from "../glyphs";

// const Weapons = {
//   Staff: new Weapon("staff", "melee", 4),
//   Spear: new Weapon("spear", "melee", 6),
//   Glaive: new Weapon("glaive", "melee", 8),
//   HuntingBow: new Weapon("hunting bow", "ranged", 6),
//   Crossbow: new Weapon("crossbow", "ranged", 7),
// }

class Weapons {
  static crook() {
    return Weapon.melee(
      Glyphs.Staff,
      "Crook",
      "A long and sturdy wooden staff made from a twisted bough.",
      4,
      "Rustic"
    );
  }

  static glaive() {
    return Weapon.melee(
      Glyphs.Glaive,
      "Glaive",
      "Heavy bladed polearm.",
      10,
      "Martial"
    );
  }

  static flintSpear() {
    return Weapon.melee(
      Glyphs.Spear,
      "Flint Spear",
      "The ancient universal weapon.",
      5,
      "Primitive"
    );
  }

  static wormtoothDagger() {
    return Weapon.melee(
      Glyphs.WormtoothDagger,
      "Wormtooth Dagger",
      "A piercing rondel carved from a fang of some monstrous underground creature.",
      6,
      "Monstrous"
    );
  }

  static farmAxe() {
    return Weapon.melee(
      Glyphs.Axe,
      "Farm Axe",
      "How much wood could a woodcutter cut?",
      5,
      "Rustic"
    );
  }

  static huntingBow() {
    return Weapon.ranged(
      Glyphs.ShortBow,
      "Hunting Bow",
      "Simple curved shortbow shaped from an elm branch.",
      Ammunition.ARROW,
      "Rustic"
    );
  }

  static hardwoodBow() {
    return Weapon.ranged(
      Glyphs.RecurveBow,
      "Hardwood Bow",
      "Elaborately twisted recurve bow shaped from mysterious black wood.",
      Ammunition.ARROW,
      "Warlike"
    );
  }

  static blowgun() {
    return Weapon.ranged(
      Glyphs.Blowgun,
      "Blowgun",
      "Hollow bamboo rod for firing piercing darts.",
      Ammunition.DART,
      "Feral"
    );
  }

  static greatAxe() {
    return Weapon.melee(
      Glyphs.Greataxe,
      "Greataxe",
      "Heavy battleaxe with a double-bladed head.",
      12,
      "Barbarian"
    );
  }

  static giantFlail() {
    return Weapon.melee(
      Glyphs.Flail,
      "Giant Fail",
      "A horrifying chained club wrought from twisted black metal.",
      26,
      "Grotesque"
    );
  }
}

export default Weapons;
